import {FC, useCallback, useMemo, useRef, useState} from 'react';
import {IRecordDetails} from '@kcast-fe/core';
import {Box, Flex} from '@chakra-ui/react';
import {HorizontalTabs, IHorizontalTab} from 'ui-kit';
import {useScreenSize} from '@kcast-fe/ui-kit';

import {MessagesTab, PromptParts} from './components';

type TInspectorTabs = 'messages' | 'prompt-parts';

interface IProps {
  records: IRecordDetails[];
}

export const MsgInspector: FC<IProps> = ({records}) => {
  const [selectedTab, setSelectedTab] = useState<TInspectorTabs>('messages');
  const record = useMemo(() => records[0], [records]);
  const scrollRef = useRef<HTMLDivElement>(null);

  const {isLessThan768} = useScreenSize();

  const tabs: IHorizontalTab[] = [
    {id: 'messages', label: `${record.model} · Messages`, count: record.message_count}
    /*{id: 'prompt-parts', label: `${record.model} · Prompt parts`}*/
  ];

  const {messages, system_prompt_parts} = record.structured;

  const handleSelectTab = useCallback((id: string | number) => {
    setSelectedTab(id as TInspectorTabs);
    scrollRef.current?.scrollTo({top: 0});
  }, []);

  return (
    <Flex w={'full'} h={'full'} flexDirection={'column'} gap={'12px'} overflow={'hidden'}>
      <Box flexShrink={0} px={isLessThan768 ? '12px' : '24px'}>
        <HorizontalTabs tabs={tabs} selectedId={selectedTab} onSelect={handleSelectTab} />
      </Box>

      <Flex
        ref={scrollRef}
        flex={'1 1 auto'}
        p={isLessThan768 ? '0 12px' : '0 24px'}
        flexDirection={'column'}
        overflowY={'auto'}
      >
        {selectedTab === 'messages' && <MessagesTab messages={messages} />}
        {selectedTab === 'prompt-parts' && <PromptParts parts={system_prompt_parts} />}
      </Flex>
    </Flex>
  );
};
